<template>
    <div class="wrapper">
        <div v-if="isOpen" />
    </div>
</template>
<script>
export default {
    $pubsub: {},
    watch: {
        isOpen: {
            immediate: true,
            handler(newVal, oldVal) {
                if (!this.ignore) {
                    if (newVal !== oldVal) {
                        this.$emit("triggerReCalc");
                    }
                }
                this.ignore = false;
            }
        },
        isPartiallyClosed: {
            immediate: true,
            handler(newVal, oldVal) {
                if (!this.ignore) {
                    if (newVal !== oldVal) {
                        this.$emit("triggerReCalc");
                    }
                }
                this.ignore = false;
            }
        }
    },
    data() {
        return {
            ignore: true
        }
    },
    props: {
        WOM: {
            required: true
        }
    },
    computed: {
        isOpen() {
            return this.WOM.isOpen;
        },
        isPartiallyClosed() {
            return this.WOM.isPartiallyClosed();
        }
    }
}
</script>
<style lang="scss" scoped>
div.wrapper {
    display: none;
}
</style>